import styles from './style.module.scss';
import { Button, PageHeader } from 'components';
import { PlusOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { Link, Route, Routes } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useShoppingCenter from '../useShoppingCenter';
import DeleteModal from 'components/deleteModalView';
import { useRecoilValue } from 'recoil';
import { getPage } from '../../../../../hooks/useUser';

const CompanyCategoriesMainPage = () => {
  const { t } = useTranslation();
  const pages = useRecoilValue(getPage);
  const {
    columns,
    data,
    loading,
    updateInProcess,
    onChangeTableFilter,
    handleDeleteCategory,
  } = useShoppingCenter(true);

  return (
    <div>
      <PageHeader title={t('OUTLET VILLAGE').toUpperCase()}>
        {pages?.ability?.can_create && (
          <Link to={'new'}>
            <Button width={'138px'} big icon={<PlusOutlined />}>
              {t('NUOVO')}
            </Button>
          </Link>
        )}
      </PageHeader>
      <div className={styles.container}>
        <Table
          columns={columns}
          dataSource={data.shopping_centers}
          pagination={data.pagination}
          onChange={onChangeTableFilter}
          loading={loading}
        />
      </div>
      <Routes>
        <Route
          path={':id/delete'}
          element={
            <DeleteModal
              onClickDelete={handleDeleteCategory}
              loading={updateInProcess}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default CompanyCategoriesMainPage;
